<template>
  <div class="bg-white md__card--holder">
    <user-picker-modal
      :visible="modals.contributors"
      modal-title="Key People"
      role="CONTRIBUTOR"
      :multi="true"
      v-model="contributors"
      :skipList="skipList"
      @input="_onContributerUsersChanged"
      @closeClicked="modals.contributors = false"
      :saveOnUserSelect="false"
    />

    <user-picker-modal
      :visible="modals.viewers"
      modal-title="Viewers"
      role="VIEWER"
      :multi="true"
      v-model="viewers"
      :skipList="skipList"
      @input="_onViewersChanged"
      @closeClicked="modals.viewers = false"
      :saveOnUserSelect="false"
    />

    <user-picker-modal
      :visible="modals.commentViewers"
      modal-title="Viewers For this activity"
      role="VIEWER"
      :multi="true"
      v-model="viewers"
      :skipList="skipList"
      @input="_onCommentViewersChanged"
      @closeClicked="modals.commentViewers = false"
      :saveOnUserSelect="false"
    />

    <LightBox
      :showLightBox="false"
      :media="lightbox.images"
      ref="lb"
      v-if="lightbox.images && lightbox.images.length > 0"
    ></LightBox>

    <UserPickerModal
      :visible="modals.assignedBy"
      title="Assigned By"
      role="CREATOR"
      :multi="false"
      v-model="task.assignedBy"
      @okClicked="_onAssignedByUsersChanged"
      @closeClicked="modals.assignedBy = false"
    />

    <UserPickerModal
      :visible="modals.assignedTo"
      title="Assigned To"
      role="ASSIGNEE"
      :multi="false"
      v-model="task.assignedTo"
      @okClicked="_onAssignedToUsersChanged"
      @closeClicked="modals.assignedTo = false"
    />

    <UserPickerModal
      :visible="modals.cc"
      title="Search to add or invite someone to this Bracket"
      role="CC"
      :multi="true"
      v-model="task.cc"
      @okClicked="_onCCUsersChanged"
      @closeClicked="modals.cc = false"
    />

    <UserPickerModal
      :visible="modals.csu"
      title="CSU To Client"
      role="CLIENT"
      :multi="true"
      v-model="task.csu"
      @okClicked="_onCSUUsersChanged"
      @closeClicked="modals.csu = false"
    />

    <div class="card border-0 chat-bar d-flex flex-column shadow-none">
      <!-- Card header -->
      <div
        class="c-aside-header d-flex align-items-center bg-white position-relative"
      >
        <div class="c-aside-header__title">
          <div
            :contenteditable="canEdit"
            @keypress.enter.prevent="onTitleChanged($event)"
            @blur="onTitleChanged($event)"
            class="c-aside-header__title-txt h6 mb-0"
            v-html="editTitle"
            @focus="_onTitleFocusClicked"
            style="min-width : 30px"
          ></div>
        </div>
        <ul
          class="c-aside-header__options d-flex mb-0 ml-auto pl-0 align-items-center"
        >
          <li
            class="c-aside-header__options-list text-center d-inline-flex justify-content-center align-items-center"
          >
            <user-avatar :data="task.assignedBy" :disableEdit="true" />
          </li>
          <li
            class="c-aside-header__options-list text-center d-inline-flex justify-content-center align-items-center"
          >
            <a
              href="javascript:void(0);"
              @click="modals.contributors = true"
              class="c-aside-header__options-key d-inline-flex icn-notification position-relative"
            >
              <span data-v-1ecabc7e="" class="icn-svg icn-key lh-1">
                <svg
                  data-v-1ecabc7e=""
                  xmlns="http://www.w3.org/2000/svg"
                  x="0"
                  y="0"
                  viewBox="0 0 22.1 22.3"
                  xml:space="preserve"
                  class="icn-svg-full"
                >
                  <path
                    data-v-1ecabc7e=""
                    fill="#2dce89"
                    d="M14 9.3c.6-2.1.3-4.3-.9-6.1C11.9 1.4 10 .2 7.8 0 5.7-.2 3.6.6 2.1 2.1S-.2 5.8 0 7.9C.2 10 1.3 12 3.1 13.2c1.8 1.2 4 1.5 6 .9l2.7 2.7c.1.1.3.2.5.2h1.9v2c0 .2.1.3.2.5.1.1.3.2.5.2h1.9v2c0 .2.1.3.2.5.1.1.3.2.5.2h3.9c.2 0 .3-.1.5-.2.1-.1.2-.3.2-.5v-3.9c0-.2-.1-.3-.2-.5l-7.9-8zM20.8 21h-2.6v-2c0-.2-.1-.3-.2-.5-.1-.1-.3-.2-.5-.2h-1.9v-2c0-.2-.1-.3-.2-.5-.1-.1-.3-.2-.5-.2h-2.3l-2.8-2.8c-.2-.2-.4-.2-.7-.2-1.7.6-3.5.4-5.1-.5-1.5-.9-2.5-2.5-2.7-4.3C1.1 6.1 1.8 4.3 3 3s3-1.9 4.8-1.7c1.8.2 3.4 1.2 4.3 2.8.9 1.5 1.1 3.4.5 5.1-.1.2 0 .5.2.7l8 8.1v3z"
                  ></path>
                  <path
                    data-v-1ecabc7e=""
                    fill="#2dce89"
                    d="M4.3 4.7c-.4.4-.6.9-.6 1.5s.2 1.1.7 1.5c.4.4 1 .6 1.6.6.6 0 1.1-.2 1.6-.6.4-.4.7-.9.7-1.5s-.4-1.1-.8-1.5c-.5-.4-1-.6-1.6-.6-.6 0-1.1.2-1.6.6zm2.1 2c-.3.3-.7.3-1 0-.3-.3-.3-.7 0-1 .1-.1.3-.2.5-.2s.4.1.5.2c.2.1.2.3.2.5s0 .4-.2.5z"
                  ></path></svg></span
              ><span data-v-1ecabc7e="" class="icn-badge bg-success">{{
                task && task.contributors && task.contributors.length
              }}</span></a
            >
          </li>
          <li
            class="c-aside-header__options-list text-center d-inline-flex justify-content-center align-items-center"
          >
            <a
              href="javascript:void((0);"
              @click="modals.viewers = true"
              class="c-aside-header__options-eye d-inline-flex icn-notification position-relative"
            >
              <span class="icn-svg icn-eye  lh-1"
                ><svg
                  data-v-1ecabc7e=""
                  xmlns="http://www.w3.org/2000/svg"
                  x="0"
                  y="0"
                  viewBox="0 0 28.1 18.2"
                  xml:space="preserve"
                  class="icn-svg-full"
                >
                  <path
                    data-v-1ecabc7e=""
                    fill="#fb6340"
                    d="M14.3 18.2c4.8 0 9.5-3 13.7-8.8.1-.2.2-.5 0-.7-.2-.3-5.8-8.5-13.9-8.7C9.2-.1 4.5 2.8.1 8.7c-.1.2-.1.5 0 .7.2.4 5.8 8.7 13.9 8.9.1-.1.2-.1.3-.1zm12.5-9.1c-4 5.4-8.3 8.1-12.7 8-6.5-.1-11.5-6.4-12.7-8 4-5.3 8.3-7.9 12.7-7.9 6.5.2 11.5 6.3 12.7 7.9z"
                  ></path>
                  <path
                    data-v-1ecabc7e=""
                    fill="#fb6340"
                    d="M14.1 14.1c1.3 0 2.6-.5 3.6-1.5.9-.9 1.5-2.2 1.5-3.5 0-1.3-.5-2.6-1.5-3.5-.9-.9-2.2-1.5-3.6-1.5s-2.6.5-3.6 1.5C9.6 6.5 9 7.8 9 9.1c0 1.3.5 2.6 1.5 3.5.9 1 2.2 1.5 3.6 1.5zm0-8.7c1 0 2 .4 2.7 1.1.7.7 1.1 1.7 1.1 2.7s-.4 2-1.1 2.7c-.7.7-1.7 1.1-2.7 1.1s-2-.4-2.7-1.1c-.7-.7-1.1-1.7-1.1-2.7 0-1 .4-2 1.1-2.7.7-.7 1.7-1.1 2.7-1.1z"
                  ></path></svg
              ></span>
              <span data-v-1ecabc7e="" class="icn-badge bg-alert">{{
                task && task.viewers && task.viewers.length
              }}</span>
            </a>
          </li>
        </ul>
        <div
          class="c-aside-header__options-close d-flex position-absolute justify-content-center align-items-center"
        >
          <button
            type="button"
            class="close close--custom-one"
            data-dismiss="modal"
            aria-label="Close"
            @click="$emit('closeClick')"
          >
            <span aria-hidden="true" class="icn-svg icn-close  lh-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 25.3"
                class="icn-svg-full"
                xml:space="preserve"
              >
                <path
                  d="m13.9 12.6 9.8-10.3c.5-.5.5-1.4 0-2-.5-.6-1.3-.5-1.9 0L12 10.7 2.3.4C1.8-.1 1-.1.4.4s-.5 1.4 0 2l9.8 10.3L.4 22.9c-.5.5-.5 1.4 0 2 .3.3.6.4.9.4.3 0 .7-.1.9-.4L12 14.6l9.8 10.3c.3.3.6.4.9.4.3 0 .7-.1.9-.4.5-.5.5-1.4 0-2l-9.7-10.3z"
                />
              </svg>
            </span>
          </button>
        </div>
      </div>
      <div class="c-aside-detail">
        <div class="c-aside-detail__head d-flex align-items-center">
          <div class="c-aside-detail__user">
            <div class="d-flex">
              <div>
                <user-avatar :data="task.assignedBy" :disableEdit="true" />
              </div>
              <div class="d-flex flex-column justify-content-center ml-2">
                <h6 class="mb-0 text-sm lh-1 mb-1">{{ assignedByName }}</h6>
                <span class="text-xs text-muted  mb-0 lh-1">{{
                  createdDate
                }}</span>
              </div>
            </div>
          </div>
          <div class="c-aside-detail__info ml-auto">
            <ul class="c-aside-timeline d-flex pl-0 mb-0 ">
              <li class="c-aside-timeline__list mx-3">
                <div class="d-flex flex-row align-items-center h-100">
                  <div
                    class="c-aside-timeline__list-item h-auto d-flex flex-column justify-content-center"
                  >
                    <small
                      class="c-aside-timeline__list-title small-54 ltr-sp-4 text-muted font-weight-bold text-uppercase lh-1 mb-1"
                    >
                      Due Date
                    </small>
                    <div
                      class="c-aside-timeline__list-duration text-xs text-alert lh-1"
                    >
                      {{ dueDate }}
                    </div>
                  </div>
                  <div class="c-aside-timeline__list-icon lh-1 ml-2">
                    <span class="icn-svg icn-calender">
                      <svg
                        class="icn-svg-full"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        viewBox="0 0 14.1 14.3"
                        style="enable-background:new 0 0 14.1 14.3"
                        xml:space="preserve"
                      >
                        <path
                          fill="#8898aa"
                          d="M2.1 12.6h2.3c.1 0 .1 0 .2-.1 0 0 .1-.1.1-.2v-2c0-.1 0-.1-.1-.2 0 0-.1-.1-.2-.1H2.1c-.1 0-.1 0-.2.1 0 0-.1.1-.1.2v2c0 .1 0 .1.1.2s.1.1.2.1zM2.1 9.1h2.3c.1 0 .1 0 .2-.1 0 0 .1-.1.1-.2v-2c0-.1 0-.1-.1-.2 0 0-.1-.1-.2-.1H2.1c-.1.2-.1.2-.2.2 0 0-.1.1-.1.2v2c0 .1 0 .1.1.2h.2zM5.9 12.6h2.3c.1 0 .1 0 .2-.1 0 0 .1-.1.1-.2v-2c0-.1 0-.1-.1-.2 0 0-.1-.1-.2-.1H5.9c-.1 0-.1 0-.2.1 0 0-.1.1-.1.2v2c0 .1 0 .1.1.2 0 .1.1.1.2.1zM5.9 9.1h2.3c.1 0 .1 0 .2-.1 0 0 .1-.1.1-.2v-2c0-.1 0-.1-.1-.2 0 0-.1-.1-.2-.1H5.9c-.1 0-.1 0-.2.1 0 0-.1.1-.1.2v2c0 .1 0 .1.1.2 0 .1.1.1.2.1zM9.6 9.1H12c.1 0 .1 0 .2-.1 0 0 .1-.1.1-.2v-2c0-.1 0-.1-.1-.2 0 0-.1-.1-.2-.1H9.6c-.1 0-.1 0-.2.1 0 0-.1.1-.1.2v2c0 .1 0 .1.1.2s.1.1.2.1zM3.3 3.5c-.1 0-.1 0-.2-.1 0 0-.1-.1-.1-.2v-3c0-.1 0-.1.1-.2h.2c.1 0 .1 0 .2.1 0 0 .1.1.1.2v3c0 .1 0 .1-.1.2-.1-.1-.2 0-.2 0z"
                        />
                        <path
                          fill="#8898aa"
                          d="M13.4 1.5h-1.9v1.7c0 .2-.1.4-.2.5-.1.1-.3.2-.5.2s-.4-.1-.5-.2c-.1-.1-.2-.3-.2-.5V1.5H4v1.7c0 .2-.1.4-.2.5-.2.2-.3.2-.5.2s-.4 0-.5-.2c-.1-.1-.2-.3-.2-.5V1.5H.7c-.2 0-.4.1-.5.2-.1.1-.2.3-.2.5v11.4c0 .2.1.4.2.5.1.1.3.2.5.2h12.7c.2 0 .4-.1.5-.2.1-.1.2-.3.2-.5V2.2c0-.2-.1-.4-.2-.5-.2-.1-.4-.2-.5-.2zm.2 12.1c0 .1 0 .1-.1.2 0 0-.1.1-.2.1H.7c-.1 0-.1 0-.2-.1 0 0-.1-.1-.1-.2V5.4h13.1v8.2z"
                        />
                        <path
                          fill="#8898aa"
                          d="M10.8 3.5c-.1 0-.1 0-.2-.1 0 0-.1-.1-.1-.2v-3c0-.1 0-.1.1-.2 0 0 .1-.1.2-.1s.1 0 .2.1c0 0 .1.1.1.2v3c0 .1 0 .1-.1.2-.1 0-.2.1-.2.1z"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
              </li>
              <li class="c-aside-timeline__list mx-3">
                <div class="d-flex flex-row align-items-center h-100">
                  <div
                    class="c-aside-timeline__list-item h-auto d-flex flex-column justify-content-center"
                  >
                    <small
                      class="c-aside-timeline__list-title small-54 ltr-sp-4 text-muted font-weight-bold text-uppercase lh-1 mb-1"
                    >
                      Time
                    </small>
                    <div
                      class="c-aside-timeline__list-duration text-xs text-alert lh-1"
                    >
                      <span
                        class="badge badge-sm badge-warning badge--custom-one mr-2"
                        >{{ workedHours }}</span
                      >
                      <span
                        class="badge badge-sm badge-alert badge--custom-one"
                        >{{ task.quoted_hours }}</span
                      >
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="c-aside-detail__toggle-btn">
            <base-dropdown
              :has-toggle="false"
              title-classes="btn btn-dot-action text-default border-0  mb-0 mr-0"
              class="dropdown--dot"
              menu-on-right
            >
              <template slot="title">
                <i class="fas fa-ellipsis-v text-xs" />
              </template>

              <div class="d-flex w-100">
                <!-- <a
                          class="dropdown-item d-flex alig-items-center lh-1"
                          href="#"
                          ><i
                            class="fas fa-minus-circle mr-2 fas--sm  text-danger"
                          ></i>
                          Delete</a
                        > -->
                <a
                  class="dropdown-item d-flex alig-items-center lh-1"
                  href="javascript:void(0);"
                  @click="_onDeleteTaskClicked(task)"
                >
                  <!-- <i
                            class="fas fa-copy mr-2 fas--sm text-success"
                          ></i> -->
                  Delete</a
                >
              </div>
            </base-dropdown>
          </div>
        </div>
        <div class="c-aside-detail__body bg-light-grey ">
          <div class="c-aside-detail__toggle">
            <div class="c-aside-detail__content">
              <p
                class="font-weight-bold text-primary"
                v-html="
                  task.comments && task.comments.length > 0
                    ? task.comments[0].description
                    : task.description
                "
              ></p>
            </div>
            <div class="c-aside-detail__img">
              <img
                v-if="
                  task.comments &&
                    task.comments.length > 0 &&
                    task.comments[0].attachments.length > 0
                "
                v-bind:src="task.comments[0].attachments[0].file_url"
                class="w-100"
              />
            </div>
          </div>
          <div class="c-aside-detail__filter d-flex">
            <div class="c-aside-detail__filter-title text-success">
              Activity {
            </div>
            <div
              class="c-aside-detail__filter-icon ml-auto d-inline-flex align-items-center"
            >
              <span class="icn-svg icn-filter">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icn-svg-full"
                  viewBox="0 0 12.1 16.1"
                  style="enable-background:new 0 0 12.1 16.1"
                  xml:space="preserve"
                >
                  <path
                    d="M3 9V0H2v9c-1.1.2-2 1.2-2 2.5 0 1.2.9 2.2 2 2.5v2.2h1V14c1.1-.2 2-1.2 2-2.5S4.1 9.2 3 9zm0 3.9c-.2 0-.3.1-.5.1s-.3 0-.5-.1c-.6-.2-1-.8-1-1.4 0-.6.4-1.2 1-1.4.2-.1.3-.1.5-.1H3c.6.2 1 .8 1 1.4 0 .7-.4 1.3-1 1.5zM12.1 4.7c0-1.2-.9-2.2-2-2.5V0h-1v2.2c-1.1.2-2 1.2-2 2.5 0 1.2.9 2.2 2 2.5v9h1v-9c1.1-.3 2-1.3 2-2.5zm-1 0c0 .6-.4 1.2-1 1.4-.2 0-.3.1-.5.1s-.3 0-.5-.1c-.6-.2-1-.8-1-1.4 0-.7.4-1.2 1-1.4.2-.1.3-.1.5-.1s.3 0 .5.1c.6.2 1 .7 1 1.4z"
                  />
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="c-aside-chat">
        <div class="c-aside-chat__wrap ">
          <p
            v-if="
              !task.comments || (task.comments && task.comments.length <= 1)
            "
            class="no-message"
          >
            Leave a Message to Start a Conversation.
          </p>
          <ul class="c-aside-chat__list list-unstyled d-flex flex-column mb-0">
            <li
              class="c-aside-chat__items"
              v-for="(comment, ind) in task.comments"
              :key="ind"
              :class="{
                'user-you': comment.from_user.user.id == profile.id,
                'user-1': comment.from_user.user.id != profile.id
              }"
            >
              <div v-if="ind > 0" class="c-aside-chat__block position-relative">
                <div class="c-aside-chat__avatar">
                  <user-avatar :data="comment.from_user" :disableEdit="true" />
                </div>
                <div class="c-aside-chat__content position-relative">
                  <div class="c-aside-chat__content-name">
                    {{
                      comment.from_user.user.first_name +
                        " " +
                        comment.from_user.user.first_name
                    }}
                  </div>
                  <div class="c-aside-chat__content-date text-primary">
                    {{ comment.age }}
                  </div>
                  <div class="c-aside-chat__content-para position-relative  ">
                    <div class="c-aside-chat__content-text">
                      <p>
                        {{ comment.description }}
                      </p>
                      <img
                        v-for="(att, i) in comment.attachments"
                        @click="_onAttachmentClicked(att)"
                        :key="i"
                        :src="att.file_url"
                        class="image-reply text-img"
                        :alt="att.file_url"
                      />
                    </div>
                    <div
                      v-if="comment.from_user.user.id == profile.id"
                      class="c-aside-chat__content-eye d-inline-block icn-notification position-absolute"
                    >
                      <span class="icn-svg icn-eye  lh-1"
                        ><svg
                          xmlns="http://www.w3.org/2000/svg"
                          x="0"
                          y="0"
                          viewBox="0 0 28.1 18.2"
                          xml:space="preserve"
                          class="icn-svg-full"
                        >
                          <path
                            fill="#CED4DA"
                            d="M14.3 18.2c4.8 0 9.5-3 13.7-8.8.1-.2.2-.5 0-.7-.2-.3-5.8-8.5-13.9-8.7C9.2-.1 4.5 2.8.1 8.7c-.1.2-.1.5 0 .7.2.4 5.8 8.7 13.9 8.9.1-.1.2-.1.3-.1zm12.5-9.1c-4 5.4-8.3 8.1-12.7 8-6.5-.1-11.5-6.4-12.7-8 4-5.3 8.3-7.9 12.7-7.9 6.5.2 11.5 6.3 12.7 7.9z"
                          ></path>
                          <path
                            fill="#CED4DA"
                            d="M14.1 14.1c1.3 0 2.6-.5 3.6-1.5.9-.9 1.5-2.2 1.5-3.5 0-1.3-.5-2.6-1.5-3.5-.9-.9-2.2-1.5-3.6-1.5s-2.6.5-3.6 1.5C9.6 6.5 9 7.8 9 9.1c0 1.3.5 2.6 1.5 3.5.9 1 2.2 1.5 3.6 1.5zm0-8.7c1 0 2 .4 2.7 1.1.7.7 1.1 1.7 1.1 2.7s-.4 2-1.1 2.7c-.7.7-1.7 1.1-2.7 1.1s-2-.4-2.7-1.1c-.7-.7-1.1-1.7-1.1-2.7 0-1 .4-2 1.1-2.7.7-.7 1.7-1.1 2.7-1.1z"
                          ></path>
                        </svg> </span
                      ><span class="icn-badge bg-light-1 text-white">{{
                        (comment.viewers && comment.viewers.length) || 0
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="tf__attachment-box">
          <div
            v-for="(file, ind) in attachments"
            :key="ind"
            class="tf__content-box"
          >
            <a
              href="javascript:void(0)"
              @click="_onDeleteAttachment(file)"
              class="tf__c-b--close"
            >
              <i class="fas fa-times"></i>
            </a>
            <div v-if="file.content_type.includes('image')" class="image">
              <img v-bind:src="file.file_url" />
              <div class="tf__c-b--filename">
                {{ file.user_file_name }}
              </div>
            </div>
            <div v-else class="file">
              <div class="tf__c-b--file">
                <img src="@/assets/img/icons/svgs/solid/arrowLeft.svg" />
              </div>
              <div class="tf__c-b--filename">
                {{ file.user_file_name }}
              </div>
            </div>
          </div>
          <div class="tf__content-box" v-if="uploading">
            <div class="loading">
              <i class="fas fa-spinner fa-pulse"></i>
            </div>
          </div>
        </div>

        <div class="c-aside-chat__msg">
          <div class="c-aside-chat__msg-wrap position-relative">
            <div class="c-aside-chat__msg-avatar position-absolute">
              <user-avatar :data="{ user: profile }" :disableEdit="true" />
            </div>
            <div class="c-aside-chat__msg-content">
              <!-- <div class="c-aside-chat__msg-input-grp">
            <input type="text" class="c-aside-chat__msg-input-txt form-control">
          </div> -->
              <div
                class="input-group c-aside-chat__msg-input-grp position-relative"
              >
                <input
                  type="text"
                  class="form-control c-aside-chat__msg-input-txt"
                  placeholder="Write your comment"
                  aria-label="Recipient's username"
                  aria-describedby="button-addon2"
                  v-if="canComment"
                  :rows="numLines"
                  v-model="comment"
                  @keydown.enter.exact="handleSubmit"
                />
                <div
                  class="input-group-append input-group-append--send position-absolute h-100"
                >
                  <button
                    class="btn d-flex align-items-center border-0 btn-send shadow-none"
                    type="button"
                    id="button-addon2"
                  >
                    <span class="icn-svg icn-send">
                      <svg
                        class="icn-svg-full"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        style="enable-background:new 0 0 512 512"
                        xml:space="preserve"
                      >
                        <path
                          d="M507.6 4.4C503.4.2 497-1.1 491.4 1.1L9.4 193.9c-5.5 2.2-9.2 7.5-9.4 13.4-.2 5.9 3.1 11.4 8.4 14l190.1 92.2 92.2 190.1c2.5 5.2 7.8 8.5 13.5 8.5h.5c5.9-.2 11.2-3.9 13.4-9.4l192.8-482c2.3-5.7 1-12.1-3.3-16.3zM52.1 209.1l382.6-153-228 228-154.6-75zm250.8 250.8-75-154.6 228-228-153 382.6z"
                          style="fill:#525f7f"
                        />
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
              <ul
                class="c-aside-chat__msg-list list-unstyled d-flex flex-row mb-0 mt-4"
              >
                <li v-if="false" class="c-aside-chat__msg-item">
                  <a
                    href="javascript:void();"
                    class="c-aside-header__options-key d-inline-flex icn-notification position-relative"
                  >
                    <span
                      data-v-2c583648=""
                      data-v-1ecabc7e=""
                      class="icn-svg icn-key lh-1"
                      ><svg
                        data-v-2c583648=""
                        data-v-1ecabc7e=""
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        viewBox="0 0 22.1 22.3"
                        xml:space="preserve"
                        class="icn-svg-full"
                      >
                        <path
                          data-v-2c583648=""
                          data-v-1ecabc7e=""
                          fill="#2dce89"
                          d="M14 9.3c.6-2.1.3-4.3-.9-6.1C11.9 1.4 10 .2 7.8 0 5.7-.2 3.6.6 2.1 2.1S-.2 5.8 0 7.9C.2 10 1.3 12 3.1 13.2c1.8 1.2 4 1.5 6 .9l2.7 2.7c.1.1.3.2.5.2h1.9v2c0 .2.1.3.2.5.1.1.3.2.5.2h1.9v2c0 .2.1.3.2.5.1.1.3.2.5.2h3.9c.2 0 .3-.1.5-.2.1-.1.2-.3.2-.5v-3.9c0-.2-.1-.3-.2-.5l-7.9-8zM20.8 21h-2.6v-2c0-.2-.1-.3-.2-.5-.1-.1-.3-.2-.5-.2h-1.9v-2c0-.2-.1-.3-.2-.5-.1-.1-.3-.2-.5-.2h-2.3l-2.8-2.8c-.2-.2-.4-.2-.7-.2-1.7.6-3.5.4-5.1-.5-1.5-.9-2.5-2.5-2.7-4.3C1.1 6.1 1.8 4.3 3 3s3-1.9 4.8-1.7c1.8.2 3.4 1.2 4.3 2.8.9 1.5 1.1 3.4.5 5.1-.1.2 0 .5.2.7l8 8.1v3z"
                        ></path>
                        <path
                          data-v-2c583648=""
                          data-v-1ecabc7e=""
                          fill="#2dce89"
                          d="M4.3 4.7c-.4.4-.6.9-.6 1.5s.2 1.1.7 1.5c.4.4 1 .6 1.6.6.6 0 1.1-.2 1.6-.6.4-.4.7-.9.7-1.5s-.4-1.1-.8-1.5c-.5-.4-1-.6-1.6-.6-.6 0-1.1.2-1.6.6zm2.1 2c-.3.3-.7.3-1 0-.3-.3-.3-.7 0-1 .1-.1.3-.2.5-.2s.4.1.5.2c.2.1.2.3.2.5s0 .4-.2.5z"
                        ></path></svg
                    ></span>
                    <span
                      data-v-2c583648=""
                      data-v-1ecabc7e=""
                      class="icn-badge bg-success"
                      >1</span
                    >
                  </a>
                </li>
                <li class="c-aside-chat__msg-item">
                  <a
                    href="javascript:void(0);"
                    @click="modals.commentViewers = true"
                    class="c-aside-header__options-key d-inline-block icn-notification position-relative"
                  >
                    <span class="icn-svg icn-eye lh-1"
                      ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        viewBox="0 0 28.1 18.2"
                        xml:space="preserve"
                        class="icn-svg-full"
                      >
                        <path
                          fill="#CED4DA"
                          d="M14.3 18.2c4.8 0 9.5-3 13.7-8.8.1-.2.2-.5 0-.7-.2-.3-5.8-8.5-13.9-8.7C9.2-.1 4.5 2.8.1 8.7c-.1.2-.1.5 0 .7.2.4 5.8 8.7 13.9 8.9.1-.1.2-.1.3-.1zm12.5-9.1c-4 5.4-8.3 8.1-12.7 8-6.5-.1-11.5-6.4-12.7-8 4-5.3 8.3-7.9 12.7-7.9 6.5.2 11.5 6.3 12.7 7.9z"
                        ></path>
                        <path
                          fill="#CED4DA"
                          d="M14.1 14.1c1.3 0 2.6-.5 3.6-1.5.9-.9 1.5-2.2 1.5-3.5 0-1.3-.5-2.6-1.5-3.5-.9-.9-2.2-1.5-3.6-1.5s-2.6.5-3.6 1.5C9.6 6.5 9 7.8 9 9.1c0 1.3.5 2.6 1.5 3.5.9 1 2.2 1.5 3.6 1.5zm0-8.7c1 0 2 .4 2.7 1.1.7.7 1.1 1.7 1.1 2.7s-.4 2-1.1 2.7c-.7.7-1.7 1.1-2.7 1.1s-2-.4-2.7-1.1c-.7-.7-1.1-1.7-1.1-2.7 0-1 .4-2 1.1-2.7.7-.7 1.7-1.1 2.7-1.1z"
                        ></path></svg
                    ></span>
                    <span class="icn-badge bg-light-1 text-white">{{
                      commentViewers.length || 0
                    }}</span>
                  </a>
                </li>
                <li class="c-aside-chat__msg-item">
                  <a
                    v-if="canComment"
                    href="javascript:void(0)"
                    @click="_onUploadClicked"
                  >
                    <span class="icn-svg icn-clip lh-1"
                      ><svg
                        class="icn-svg-full"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 21.4 20"
                        style="enable-background:new 0 0 21.4 20"
                        xml:space="preserve"
                      >
                        <path
                          d="M14.7 0c1.8 0 3.5.7 4.7 2.1 1.2 1.3 1.9 3 1.9 4.9 0 1.9-.7 3.7-1.9 5l-6.6 7c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1.1 0-1.5l6.6-7c.9-.9 1.4-2.2 1.4-3.5 0-1.3-.5-2.5-1.4-3.4-1.8-1.9-4.9-1.9-6.6 0l-8.6 9.1c-1.1 1.2-1.1 3.1 0 4.3.5.6 1.2.9 2 .9s1.5-.3 2.1-.9l7.8-8.3c.2-.3.3-.6.3-.8 0-.3-.1-.5-.3-.7-.4-.4-1.1-.4-1.5 0L9.6 11c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1.1 0-1.5l3.7-3.9c1.1-1.2 3.1-1.2 4.2 0 .6.6.9 1.4.9 2.2 0 .8-.3 1.6-.8 2.2v.1l-7.9 8.4c-.9 1-2.1 1.5-3.4 1.5-1.3 0-2.5-.6-3.4-1.5-1.9-2-1.9-5.2 0-7.2L10 2.1C11.3.7 12.9 0 14.7 0z"
                          style="fill:#5e72e4"
                        />
                      </svg>
                    </span>
                  </a>
                </li>
              </ul>

              <div class="chat-box__subtext">
                <vue-clip
                  :options="dropzoneOptions"
                  :on-removed-file="_onFileRemoved"
                  :on-complete="_onComplete"
                  :on-added-file="_onFileAdded"
                >
                  <template slot="clip-uploader-action">
                    <div>
                      <div class="dz-message">
                        <!-- <h5>Click Here or Drop files here</h5> -->
                      </div>
                    </div>
                  </template>

                  <template slot="clip-uploader-body"> </template>
                </vue-clip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import { required, minLength, between, email } from "vuelidate/lib/validators";
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import UserPickerModal from "@/app/components/UserPickerModal.vue";
import UserPicker from "@/app/components/UserPicker.vue";
import LightBox from "@/libs/lightbox/LightBox.vue";
import moment from "moment";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import { isMobile } from "mobile-device-detect";
import UserAvatar from "./UserAvatar.vue";

//import LightBox from 'vue-image-lightbox'

export default {
  name: "AssetThread",
  props: ["editId", "data", "quoteView"],
  data() {
    return {
      isMobile: isMobile,
      resource: {},
      quoteExpanded: this.quoteView || false,
      resourceAddVisible: false,
      hasCsu: false,
      selectedResource: {},
      commentViewers: [],
      lightbox: {
        images: [],
        startIndex: 0
      },
      modals: {
        assignedBy: false,
        assignedTo: false,
        cc: false,
        csu: false,
        contributors: false,
        viewers: false,
        approvers: false,
        commentViewers: false
      },
      project_id: null,
      uploading: false,
      attachments: [],
      comment: null,
      deadline: moment().format("YYYY-M-D"),
      task: {
        asset_users: [],
        title: "Unnamed Task"
      },
      message: null,
      dropzoneOptions: {
        url: process.env.VUE_APP_BASE_URL + "/v2/attachments",
        thumbnailWidth: 150,
        maxFilesize: 2,
        thumbnailWidth: 200,
        paramName: "attachment",
        headers: {
          Authorization: "Bearer " + this.$auth.getToken()
        }
      },

      editTitle: "Unnamed Task"
    };
  },
  components: {
    HtmlEditor,
    flatPicker,
    UserPickerModal,
    UserPicker,
    UserAvatar,
    LightBox
  },
  validations: {
    projectTitle: {
      required,
      minLength: minLength(4)
    },
    projectType: {
      required
    },
    client: {
      required
    }
  },

  watch: {
    editId(newVal, oldVal) {
      console.log(oldVal, newVal, "9++++++++++");
      if (newVal != oldVal) {
        if (newVal) {
          this.fetchTask(newVal);
        } else {
          this.initForm();
        }
      } else {
        this.initForm();
      }
    }
  },

  computed: {
    ...mapState("user", ["profile"]),
    ...mapState("common", ["roles", "resources", "currencies"]),
    numLines() {
      return (this.comment && this.comment.split(/\r\n|\r|\n/).length) || 1;
    },

    assignedByName() {
      if (this.task && this.task.assignedBy) {
        return (
          this.task.assignedBy.user.first_name +
          " " +
          this.task.assignedBy.user.last_name
        );
      }
      return "N/A";
    },

    contributors: {
      get: function() {
        return this.task.contributors || [];
      },
      set: function(value) {
        this.task.contributors = value;
      }
    },

    viewers: {
      get: function() {
        return this.task.viewers || [];
      },
      set: function(value) {
        this.task.viewers = value;
      }
    },

    approvers: {
      get: function() {
        return this.task.approvers || [];
      },
      set: function(value) {
        this.task.approvers = value;
      }
    },

    createdDate() {
      return moment(this.task.created_at).fromNow();
    },

    dueDate() {
      return moment(this.task.deadline).fromNow();
    },

    skipList() {
      let arr = [...(this.contributors || []), ...(this.viewers || [])];
      if (this.task.assignedBy) {
        arr.push(this.task.assignedBy);
      }

      if (this.task.assignedTo) {
        arr.push(this.task.assignedTo);
      }

      return [];
    },

    workedHours() {
      return (parseInt(this.task.total_seconds) / 60 / 60).toFixed(0);
    },

    canEdit() {
      if (this.task.id)
        return (
          this.task && this.task.permission && this.task.permission.edit == 1
        );
      else return true;
    },
    canComment() {
      if (this.task.id)
        return (
          this.task && this.task.permission && this.task.permission.comment == 1
        );
      else return true;
    },

    taskBudget() {
      let totalHours = 0;
      let totalCost = 0;
      let t = this.task || {};

      totalCost = parseFloat((t.hourly_cost || 0) * (t.quoted_hours || 0));
      totalHours = parseInt(t.quoted_hours || 0);
      const dp = isNaN(parseInt(t.discount_percentage))
        ? 0
        : parseInt(t.discount_percentage);
      const numOfDays = parseInt(t.no_of_days || 1);
      totalCost = (totalCost - (totalCost * dp) / 100) * numOfDays;
      if (totalCost >= 1000) {
        totalCost = (totalCost / 1000).toFixed(1) + "k";
      }

      return (
        (this.profile && this.profile.currency.symbol) +
        totalCost +
        " | " +
        totalHours +
        " Hours"
      );
    }
  },

  created() {
    //hide sidebar and modals on esc key
    document.addEventListener("keyup", evt => {
      if (evt.keyCode === 27) {
        let canHideSideBar = true;
        Object.keys(this.modals).map(key => {
          if (this.modals[key]) {
            this.modals[key] = false;
            canHideSideBar = false;
          }
          return key;
        });

        //console.log("esc", canHideSideBar)
        if (canHideSideBar) {
          this.$emit("closeClick");
        }
      }
    });
  },

  async mounted() {
    console.log("mounted+++++++", this.$route);
    // console.log(this.$router, this.$route, "ddddd")

    this.project_id = this.$route.params["id"];
    this.setLoading(true);
    await this.fetchRoles();
    await this.fetchResources();
    if (!this.editId) {
      this.initForm();
    } else {
      //this.editTitle = "Edit Task";
      await this.fetchTask(this.editId);
      //this.deadline = moment(this.task.deadline).format("DD-MM-YYYY")
    }

    this.setLoading(false);

    this.$nextTick(() => {
      // $('[data-toggle="tooltip"]').tooltipster({
      //   theme: "tooltipster-borderless"
      // });
    }, 400);
  },

  methods: {
    ...mapActions("user", ["fetchAllUsers"]),
    ...mapActions("task", [
      "fetchAllTasksByProjectId",
      "fetchSingleTask",
      "createTask",
      "updateTask",
      "deleteTask",
      "createAssetThread"
    ]),
    ...mapActions("common", [
      "fetchRoles",
      "fetchResources",
      "deteteAttachment",
      "fetchCurrencies"
    ]),
    ...mapMutations(["setGanttRender", "setLoading"]),
    _onCommentViewersChanged() {},

    _onTitleFocusClicked() {
      if (this.editTitle == "Unnamed Task") {
        this.editTitle = "";
      }
    },
    initForm() {
      let role = this.roles.filter(r => r.name == "CREATOR")[0];
      let assigneeRole = this.roles.filter(r => r.name == "ASSIGNEE")[0];
      let assigner = {
        ...this.profile
      };

      this.editTitle = "Unnamed Task";
      this.task = {
        id: null,
        assignedBy: {
          user: assigner,
          asset_role: role
        },
        assignedTo: {
          user: assigner,
          asset_role: assigneeRole
        },
        name: this.editTitle,
        comments: [],
        csu: [],
        cc: []
      };
      this.deadline = moment().format("YYYY-M-D");
    },

    _onCancelQuoteClicked() {
      this.quoteExpanded = false;
    },

    _onHoursClicked() {
      this.quoteExpanded = false; //hidden always as michael said it
    },

    async _onAddRateClicked() {
      await this.fetchCurrencies();
      this.resourceAddVisible = true;
    },

    _onFileAdded() {
      this.uploading = true;
    },
    _onFileRemoved(file) {},

    _onComplete(file, status, xhr) {
      this.uploading = false;

      if (file.errorMessage) {
        this.$snack.success(file.errorMessage);
      } else {
        let body = JSON.parse(xhr.response);
        this.attachments = [...this.attachments, body.data];
        console.log(xhr.response, "came after upload");
      }
    },

    onSaveResourceClicked() {},

    async _onSaveQuoteClicked() {
      if (this.task.id) {
        try {
          const r = await this.saveTask(false);
          this.quoteExpanded = false;
          if (r) {
            this.$snack.success("Quote updated Successfully");
          }
        } catch (e) {}
      } else {
        try {
          const r = await this.saveTask(false);
          this.quoteExpanded = false;
          if (r) {
            this.$snack.success("Quote Created Successfully");
          }
        } catch (e) {}
      }
    },

    async _onCompleteClicked() {
      if (this.task.id) {
        try {
          this.task.status = this.task.status == "CLOSED" ? "OPEN" : "CLOSED";
          await this.saveTask(false);
        } catch (e) {}
      }
    },

    onDeadlineChanged(deadline) {
      console.log("hahahah", deadline, moment(deadline[0]).format("YYYY-M-D"));

      if (this.task.id) {
        this.task.deadline = moment(deadline[0]).format("YYYY-M-D");
        this.task.end_date = moment(deadline[0]).format("YYYY-M-D");
        this.saveTask(false);
      }
    },

    _onUploadClicked() {
      if (this.canComment) {
        document.getElementsByClassName("dz-clickable")[0].click();
      } else {
        this.$snack.success("You dont have permission to comment");
      }
    },

    async _onDeleteAttachment(attachment) {
      try {
        await this.deteteAttachment(attachment);
        this.attachments = this.attachments.filter(r => r.id != attachment.id);
      } catch (e) {
        console.log(e);
      }
    },

    async onTitleChanged(event) {
      this.editTitle = event.target.innerHTML;
      let existingTitle = this.task.name;
      if (this.task && this.task.permission && this.task.permission.edit == 0)
        return false;
      if (event.target.innerHTML.length < 5) {
        swal({
          title:
            "Are you sure you want to change the name of this ticket from " +
            existingTitle +
            " to " +
            event.target.innerHTML +
            "?",
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes, change it!",
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.task.name = this.editTitle;
            if (existingTitle != this.task.name && this.task.id)
              this.saveTask(false);
            return false;
          } else {
            this.editTitle = existingTitle;
            return false;
          }
        });
        return false;
      } else if (event.target.innerHTML.length > 50) {
        swal({
          title: "Task title is too long",
          type: "warning",
          // showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "OK",
          buttonsStyling: false
        }).then(result => {});
        return false;
      } else {
        this.task.name = this.editTitle;
        //alert(this.task.id)
        if (existingTitle != this.task.name && this.task.id != null)
          this.saveTask(false);
        return false;
      }
    },

    async saveTask(refresh = true, userType = null) {
      this.task.parent_id = this.project_id;
      let body = {
        ...this.task,
        from: userType
      };
      if (
        body.discount_percentage == "None" ||
        body.discount_percentage == "N/A"
      ) {
        body.discount_percentage = 0;
      }

      if (body.id) {
        try {
          let res = await this.updateTask(body);
          //await this.fetchTask(this.task.id)
          await this.fetchTask(body.id, refresh);
          this.setGanttRender();
          this.$emit("taskCreated", body.id, refresh);
          this.$snack.success("Task has been changed successfully");
        } catch (e) {
          console.log("Error in saving task ", e);
          this.$snack.success("Error occured while saving task");
        }
      } else {
        if (body.name == null || body.name == "") {
          this.$snack.success("Task title is required");
          return Promise.reject(false);
        }

        if (!body.assignedBy) {
          this.$snack.success("Assigned By user is required");
          return Promise.reject(false);
        }

        if (!body.assignedTo) {
          this.$snack.success("Assigned To user is required");
          return Promise.reject(false);
        }

        let res = await this.createTask(body);
        //await this.fetchTask(this.task.id)
        await this.fetchTask(res.data.id, refresh);
        this.setGanttRender();
        this.$emit("taskCreated", res.data.id, refresh);
        return Promise.resolve(true);
      }
    },

    onResourceChanged() {
      this.task.hourly_cost = this.task.resource.hourly_cost;
    },

    async fetchTask(val, refresh) {
      try {
        const res = await this.fetchSingleTask({
          val,
          refresh
        });
        this.task = res.data || {};
        if (
          this.task.discount_percentage == 0 ||
          this.task.discount_percentage
        ) {
          this.task.discount_percentage = "None";
        }

        this.deadline = moment(this.task.end_date).format("YYYY-M-D");
        console.log(
          "daidai",
          moment(this.task.end_date),
          moment(this.task.end_date).format("YYYY-M-D")
        );

        this.editTitle = this.task.name;

        this.task.comments.map(comment => {
          this.lightbox.images = [
            ...this.lightbox.images,
            ...comment.attachments.map(att => {
              att.thumb = att.src = att.file_url;
              att.type = att.type;
              return att;
            })
          ];
        });
      } catch (e) {
        this.task = {};
        this.$snack.success("Could not fetch task");
      }
    },

    userAvatar(user) {
      let avatar = "";
      let bg_colors = [
        "bg-success",
        "bg-info",
        "bg-default",
        "bg-darker",
        "bg-danger"
      ];
      let bg = "bg-success";
      let hasImage = false;
      if (user) {
        if (user.profile_pic != null) {
          avatar = user.profile_pic.file_url;
          hasImage = true;
        } else {
          hasImage = false;
          let ch =
            user.first_name && user.first_name.substring(0, 1).toUpperCase();
          bg = bg_colors[(ch.charCodeAt(0) + user.first_name.length) % 5];
          avatar =
            user.first_name &&
            user.first_name.substring(0, 1).toUpperCase() +
              (
                (user.last_name && user.last_name.substring(0, 1)) ||
                ""
              ).toUpperCase();
        }
      } else {
        avatar = "NU";
        //task_return += '<span class="mr-1"><i class="fas fa-arrow-'+task.which_task+'"></i></span>';
      }

      // <span data-toggle="tooltip" data-trigger="hover" title="No User" class="d-flex mr-1"><a href="#" class="avatar avatar-name avatar-sm  '+bg+' text-xl text-white rounded-circle" data-target="offcanvasFrom" data-offcanvasfrom="offcanvas">NU</a></span>

      return {
        hasImage: hasImage,
        avatar: avatar,
        bg: bg
      };
    },

    _onAssignedByUsersChanged(data) {
      this.task.assignedBy = data;
      this.modals.assignedBy = false;
      if (this.task.id) this.saveTask(false, 'ASSIGNEE');
    },

    _onAssignedToUsersChanged(data) {
      console.log(data);
      this.task.assignedTo = data;
      this.modals.assignedTo = false;
      if (this.task.id) this.saveTask(false);
    },

    _onCCUsersChanged(data) {
      console.log("csu use changed");
      this.task.cc = data;
      this.modals.cc = false;
      if (this.task.id) this.saveTask(false, 'CC');
    },

    _onCSUUsersChanged(data) {
      alert('_onCSUUsersChanged')
      console.log("csu use changed");
      this.task.csu = data;
      this.modals.csu = false;
      if (this.task.id) this.saveTask(false, 'CSU');
    },

    async _onContributerUsersChanged(v) {
      console.log(v, "dada");
      //return false
      if (
        this.profile &&
        this.profile.role &&
        this.profile.role.name == "guest"
      ) {
        return false;
      }
      //add user to current project and fetch data
      try {
        if (this.task.id) this.saveTask(false, 'CONTRIBUTOR');
        this.modals.contributors = false;
      } catch (e) {
        console.log(e, "Error updating projec t");
      }

      //this.setSingleProject({...this.project, contributors: this.contributors})
      //  alert("call api which adds contributors users to current project")
    },

    async _onApproversChanged() {
      console.log(this.project, "dada");
      if (
        this.profile &&
        this.profile.role &&
        this.profile.role.name == "guest"
      ) {
        return false;
      }
      //add user to current project and fetch data
      if (this.task.id) this.saveTask(false);
      this.modals.approvers = false;
    },

    async _onViewersChanged(v) {
      console.log(v, "dada");
      if (
        this.profile &&
        this.profile.role &&
        this.profile.role.name == "guest"
      ) {
        return false;
      }
      //add user to current project and fetch data
      try {
        if (this.task.id) this.saveTask(false, 'VIEWER');
        this.modals.viewers = false;
      } catch (e) {
        console.log(e, "Error updating task");
      }

      //this.setSingleProject({...this.project, contributors: this.contributors})
      //  alert("call api which adds contributors users to current project")
    },

    _onDeleteTaskClicked(task) {
      swal({
        title: "Are you sure to delete this task?",
        text: `Please click Yes to proceed!`,
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteSelectedTask(task, true);
        }
      });
    },

    async deleteSelectedTask(task, refresh = true) {
      // task.parent_id = this.project.id;
      if (task.id) {
        if (
          this.profile &&
          this.profile.role &&
          this.profile.role.name != "guest"
        ) {
          try {
            let res = await this.deleteTask(task);
            //await this.fetchTask(this.task.id)
            await this.fetchAllTasksByProjectId(task.parent_id);

            this.$emit("taskDeleted", refresh);
            //this.$emit("taskCreated", refresh);
            saving = false;
            this.$snack.success("Task Has been deleted successfully");
          } catch (e) {
            saving = false;
            console.log("Erro task update ", e);
            this.$snack.success("Error occured while deleting task");
          }
        } else {
          this.$snack.success("You can not delete task on guest mode");
        }
      }
    },

    async handleSubmit() {
      // if(this.task.id != null && this.task.id !=undefined && this.task.approval_status != "APPROVED" && task.approval_status != "APPROVED") {
      //   this.$snack.success("Task is not approved yet. You can't start working on it");
      //   return;
      // }
      // confused

      if ((this.comment == null || this.comment == "") && !this.attachments) {
        return;
      }

      if (this.task.name == null || this.task.name == "") {
        this.$snack.success("Task title is required");
        return;
      }

      if (!this.task.assignedBy) {
        this.$snack.success("Task From is required");
        return;
      }

      if (!this.task.assignedTo) {
        this.$snack.success("Task To is required");
        return;
      }

      // add task by and task to validations

      // if (this.task.months == null || this.task.months == "") {
      //   this.$snack.success("Months is required");
      //   return;
      // }

      // if (this.task.deadline == null || this.task.deadline == "") {
      //   this.$snack.success("Deadline is required");
      //   return;
      // }

      // if (this.task.resource) {
      //   if (this.task.hourly_cost == null || this.task.hourly_cost == "") {
      //     this.$snack.success("Please enter total rate");
      //     return;
      //   }

      //   if (this.task.quoted_hours == null || this.task.quoted_hours == "") {
      //     this.$snack.success("Please enter total hours");
      //     return;
      //   }
      // } else {
      //   this.$snack.success("Select price resource");
      // }

      this.setLoading(true);
      let asset = {
        ...this.task,
        parent_id: this.project_id
      };

      if (asset.discount_percentage == "None") {
        asset.discount_percentage = 0;
      }

      if (this.editId) {
        asset.id = this.editId;
      }

      let body = {
        asset: asset,
        from_user: {
          user: this.profile
        },
        attachments: this.attachments,
        description: this.comment || ""
      };

      try {
        let res = await this.createAssetThread(body);

        await this.fetchTask(res.data.asset.id);
        this.setGanttRender();
        this.$emit("taskCreated", res.data.asset.id);
        this.comment = null;
        this.attachments = [];
        this.setLoading(false);
      } catch (e) {
        console.log(e);
        this.$snack.success("Could not create thread");
        this.setLoading(false);
      }
    },

    _onAttachmentClicked(attachment) {
      this.lightbox.startIndex = this.lightbox.images.findIndex(
        a => attachment.file_url == a.file_url
      );
      this.$refs["lb"].showImage(this.lightbox.startIndex);
    }
  } //end methods
};
</script>

<style scoped>
textarea.form-control {
  /* height: calc(1.5em + 1.25rem + 5px); */
  padding-right: 40px;
  padding-left: 20px;
}

.chat-head {
  position: relative;
}

.chat-head .chat-close {
  position: absolute;
  right: 10px;
  top: 5px;
  left: auto;
}

.chat-head .chat-close:hover {
  color: #11cdef !important;
}

.cancel-btn,
.success-btn {
  padding: 10px;
}

.btn-row .btn-col-left {
  padding-right: 5px;
}

.btn-row .btn-col-right {
  padding-left: 5px;
}

.form-control-chatbox {
  height: calc(1.5em + 1.25rem + 2px);
}

.title-btn .title-btn-child {
  padding: 11px 10px;
  box-shadow: none;
}

.title-btn .title-btn-child:hover {
  webkit-box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
  box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
}

@media only screen and (max-width: 991px) {
  .chat-header-container {
    flex-direction: column;
  }

  .title-btn {
    padding-top: 10px;
  }
}

@media only screen and (max-width: 767px) {
  .title-btn {
    flex-direction: column;
    align-items: flex-start !important;
    justify-content: flex-start !important;
  }

  .title-btn-child {
    margin-left: 0 !important;
  }
}

.assets-thread {
  background: #212529;
  padding: 0.7rem 1.5rem;
  border-bottom: 5px solid #fbdf43;
  border-radius: 0;
}

.assets-thread.green-class {
  border-bottom: 5px solid #2dce89;
}

.assets-thread.yellow-class {
  border-bottom: 5px solid #fbdf43;
}

.assets-thread .task-title {
  color: #fff;
  margin-top: 4px;
}
</style>
